import { saveDataMemoryService } from "@/business/shared/session/infrastructure/services/saveDataMemoryService";
import { userAuthStore } from "@/business/auth/infrastructure/store/userAuthStore";

export const saveSession = {
  async execute(): Promise<void> {
    const userAuthIsEmpty = userAuthStore().isEmpty.value;

    const user = userAuthIsEmpty
      ? null
      : userAuthStore().memoryUserAuth;

    await saveDataMemoryService.execute(user);
  },
};